import React, { useRef, useState } from 'react';
// import { useDispatch, useSelector } from "react-redux";

import { useElements } from '../../../lib/yjs';

import {
    // TableIconNewSmall,
    TableIconNewControlsSmall,
    ArrowIcon,
    KeyIconSmall,
    IndexIcon,
} from '../../Icon';

import './PanelLeft.scss';

export const PanelLeft = ({ wrapClass = '', isVisible = false }) => {
    // dispatch
    // const dispatch = useDispatch();

    // selectors
    const elementsRedux = useElements();

    // const focusedElementsIds = useSelector(selectFocusedElementsIds);
    // const focusedInsideElementRedux = useSelector(selectFocusedInsideElement);
    const tables = {};
    const notes = {};

    Object.keys(elementsRedux || {}).forEach((key) => {
        const element = elementsRedux[key];

        if (element.type === 'table') {
            tables[element.id] = element;
        } else {
            notes[element.id] = element;
        }
    });

    const clickTimesRef = useRef([]);
    const [selectedElementId, setSelectedElementId] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [selectedNestedItemId, setSelectedNestedItemId] = useState(null);

    const [activeElements, setActiveElements] = useState({});
    const [activeItems, setActiveItems] = useState({});

    const [isStateChanged, setIsStateChanged] = useState(false);

    function handleTableClick(tableId) {
        clickTimesRef.current = [
            ...(clickTimesRef.current || []),
            new Date().getTime(),
        ];

        let isDoubleClick = false;
        if (clickTimesRef.current.length >= 2) {
            const firstTime =
                clickTimesRef.current[clickTimesRef.current.length - 2];
            const lastTime =
                clickTimesRef.current[clickTimesRef.current.length - 1];
            const diffTime = lastTime - firstTime;

            clickTimesRef.current = clickTimesRef.current.slice(
                1,
                clickTimesRef.current.length
            );
            isDoubleClick = diffTime <= 250;
        }

        // double click
        if (isDoubleClick) {
            handleTableOneClick(tableId);
            Math.random() === 12 && handleTableDoubleClick(tableId);

            // single click
        } else {
            handleTableOneClick(tableId);
        }
    }
    function handleTableOneClick(tableId) {
        // ACTIVE ELEMENTS

        // clicked element is active
        if (Object.keys(activeElements).includes(tableId)) {
            delete activeElements[tableId];
            setActiveElements(activeElements);

            const columnsId = `${tableId}_columns`;
            const indexesId = `${tableId}_indexes`;
            const keysId = `${tableId}_keys`;
            delete activeItems[columnsId];
            delete activeItems[indexesId];
            delete activeItems[keysId];
            setActiveItems(activeItems);

            setIsStateChanged(!isStateChanged);

            // clicked element is not active
        } else {
            const id = `element_body_${tableId}`;
            const element = document.getElementById(id);

            setActiveElements({
                ...activeElements,
                [tableId]: element.scrollHeight,
            });
            setIsStateChanged(!isStateChanged);
        }

        // SELECTED ELEMENTS
        if (!selectedElementId || selectedElementId !== tableId) {
            setSelectedElementId(tableId);
            setSelectedItemId(null);
            setSelectedNestedItemId(null);
        }
    }
    function handleTableDoubleClick(tableId) {
        if (!selectedElementId || selectedElementId !== tableId) {
            setSelectedElementId(tableId);
            setSelectedItemId(null);
            setSelectedNestedItemId(null);
        }
    }

    // function handleItemClick(tableId, itemId) {
    // 	// ACTIVE ITEMS
    // 	const itemKey = `${tableId}_${itemId}`;

    // 	// clicked item is active
    // 	if (Object.keys(activeItems).includes(itemKey)) {
    // 		delete activeItems[itemKey];
    // 		setActiveItems(activeItems);

    // 		const msDiff = 400 - 250;
    // 		setTimeout(() => { setActiveElements({ ...activeElements, [tableId]: 85 }); }, msDiff);

    // 		setIsStateChanged(!isStateChanged);

    // 		// clicked element is not active
    // 	} else {
    // 		const id = `element_item_body_${tableId}_${itemId}`;
    // 		const item = document.getElementById(id);
    // 		setActiveItems({ ...activeItems, [itemKey]: item.scrollHeight });

    // 		const elementId = `element_body_${tableId}`;
    // 		const element = document.getElementById(elementId);

    // 		// const sumHeight = element.scrollHeight + item.scrollHeight;
    // 		let sumHeight = element.scrollHeight + item.scrollHeight;

    // 		const columnsItemKey = `${tableId}_columns`;
    // 		const indexesItemKey = `${tableId}_indexes`;
    // 		const keysItemKey = `${tableId}_keys`;

    // 		// columns
    // 		if (activeItems[columnsItemKey] && itemId !== 'columns') {
    // 			const tempId = `element_item_body_${columnsItemKey}`;
    // 			const tempIdItem = document.getElementById(tempId);
    // 			sumHeight += tempIdItem.scrollHeight;
    // 		}

    // 		// indexes
    // 		if (activeItems[indexesItemKey] && itemId !== 'indexes') {
    // 			const tempId = `element_item_body_${indexesItemKey}`;
    // 			const tempIdItem = document.getElementById(tempId);
    // 			sumHeight += tempIdItem.scrollHeight;
    // 		}

    // 		// keys
    // 		if (activeItems[keysItemKey] && itemId !== 'keys') {
    // 			const tempId = `element_item_body_${keysItemKey}`;
    // 			const tempIdItem = document.getElementById(tempId);
    // 			sumHeight += tempIdItem.scrollHeight;
    // 		}

    // 		// const elementHeight = element.scrollHeight === 85 ? element.scrollHeight + item.scrollHeight : element.scrollHeight;
    // 		const elementHeight = sumHeight; //element.scrollHeight === 85 ? sumHeight : element.scrollHeight;
    // 		setActiveElements({ ...activeElements, [tableId]: elementHeight });

    // 		setIsStateChanged(!isStateChanged);
    // 	}

    // 	// SELECTED ITEM
    // 	if (!selectedItemId || selectedItemId !== `${tableId}_${itemId}`) {
    // 		setSelectedItemId(`${tableId}_${itemId}`);
    // 		setSelectedElementId(null);
    // 		setSelectedNestedItemId(null);
    // 	}

    // }

    function handleItemClick(tableId, itemId) {
        const elementId = `element_body_${tableId}`;
        const element = document.getElementById(elementId);
        let sumHeight = element.scrollHeight;

        // ACTIVE ITEMS
        const itemKey = `${tableId}_${itemId}`;

        // clicked item is active
        if (Object.keys(activeItems).includes(itemKey)) {
            delete activeItems[itemKey];
            setActiveItems(activeItems);

            // clicked element is not active
        } else {
            const id = `element_item_body_${tableId}_${itemId}`;
            const item = document.getElementById(id);
            setActiveItems({ ...activeItems, [itemKey]: item.scrollHeight });
            sumHeight += item.scrollHeight;
        }

        const columnsItemKey = `${tableId}_columns`;
        const indexesItemKey = `${tableId}_indexes`;
        const keysItemKey = `${tableId}_keys`;

        // columns
        if (activeItems[columnsItemKey] && itemId !== 'columns') {
            const tempId = `element_item_body_${columnsItemKey}`;
            const tempIdItem = document.getElementById(tempId);
            sumHeight += tempIdItem.scrollHeight;
        }

        // indexes
        if (activeItems[indexesItemKey] && itemId !== 'indexes') {
            const tempId = `element_item_body_${indexesItemKey}`;
            const tempIdItem = document.getElementById(tempId);
            sumHeight += tempIdItem.scrollHeight;
        }

        // keys
        if (activeItems[keysItemKey] && itemId !== 'keys') {
            const tempId = `element_item_body_${keysItemKey}`;
            const tempIdItem = document.getElementById(tempId);
            sumHeight += tempIdItem.scrollHeight;
        }

        // const msDiff = 400 - 250;
        // setTimeout(() => { setActiveElements({ ...activeElements, [tableId]: 85 }); }, msDiff);
        // setIsStateChanged(!isStateChanged);

        setActiveElements({ ...activeElements, [tableId]: sumHeight });
        setIsStateChanged(!isStateChanged);

        // SELECTED ITEM
        if (!selectedItemId || selectedItemId !== `${tableId}_${itemId}`) {
            setSelectedItemId(`${tableId}_${itemId}`);
            setSelectedElementId(null);
            setSelectedNestedItemId(null);
        }
    }

    function handleNestedItemClick(tableId, itemId, nestedItemId) {
        const nestedItemKey = `${tableId}_${itemId}_${nestedItemId}`;

        // SELECTED NESTED ITEM
        if (!selectedNestedItemId || selectedNestedItemId !== nestedItemKey) {
            setSelectedNestedItemId(nestedItemKey);
            setSelectedItemId(null);
            setSelectedElementId(null);
        }
    }

    // tables list
    const tablesList = (
        <div className="elements">
            <div className="elements_header">
                {Math.random() === 12 && (
                    <div className="elements_header">Tables</div>
                )}
                {Math.random() === 12 && (
                    <div
                        className="elements_header"
                        onClick={() => {
                            setActiveElements({});
                            setActiveItems({});
                        }}
                    >
                        btn
                    </div>
                )}
            </div>
            <div className="elements_body">
                {Object.keys(tables || {}).map((tableKey, tableIndex) => {
                    const table = tables[tableKey];

                    const columnsCount = Object.keys(
                        table.columns || {}
                    )?.length;
                    const indexesCount = Object.keys(
                        table.columns || {}
                    ).filter(
                        (keyItem) => table.columns[keyItem].index
                    ).length;
                    const keysCount = Object.keys(
                        table.columns || {}
                    ).filter(
                        (keyItem) =>
                            table.columns[keyItem].isPK ||
                            table.columns[keyItem].isFK
                    ).length;

                    return (
                        <div
                            id={`element_${tableKey}`}
                            key={`${tableKey}-${tableIndex}`}
                            className={`element ${
                                selectedElementId === table.id ? 'selected' : ''
                            } ${activeElements[table.id] ? 'active' : ''}`}
                        >
                            <div
                                className="element_header"
                                onClick={() => {
                                    handleTableClick(table.id);
                                }}
                            >
                                <div className="element_header_icon_arrow">
                                    <ArrowIcon />
                                </div>
                                <div className="element_header_icon_table">
                                    <TableIconNewControlsSmall />
                                </div>
                                <div className="element_header_title">
                                    {table?.name}
                                </div>
                            </div>
                            <div
                                id={`element_body_${tableKey}`}
                                className="element_body"
                                style={
                                    activeElements[table.id]
                                        ? {
                                              maxHeight:
                                                  activeElements[table.id],
                                          }
                                        : {}
                                }
                            >
                                {/* COLUMNS */}

                                <div
                                    id={`element_item_${tableKey}_columns`}
                                    className={`element_body_item ${
                                        activeItems[`${table.id}_columns`]
                                            ? 'active'
                                            : ''
                                    }  ${
                                        selectedItemId === `${table.id}_columns`
                                            ? 'selected'
                                            : ''
                                    }`}
                                >
                                    <div
                                        className="element_body_item_header"
                                        onClick={() => {
                                            handleItemClick(
                                                table.id,
                                                'columns'
                                            );
                                        }}
                                    >
                                        <div className="element_body_item_header_icon_arrow">
                                            <ArrowIcon />
                                        </div>
                                        <div className="element_body_item_header_title">
                                            Columns
                                            {columnsCount ? (
                                                <span>{columnsCount}</span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        id={`element_item_body_${tableKey}_columns`}
                                        className="element_body_item_body"
                                        style={
                                            activeItems[`${table.id}_columns`]
                                                ? {
                                                      maxHeight:
                                                          activeItems[
                                                              `${table.id}_columns`
                                                          ],
                                                  }
                                                : {}
                                        }
                                    >
                                        {isVisible &&
                                            Object.keys(
                                                table.columns || {}
                                            ).map((columnKey, columnIndex) => {
                                                const column =
                                                    table.columns[
                                                        columnKey
                                                    ];
                                                return (
                                                    <div
                                                        className={`column ${
                                                            selectedNestedItemId ===
                                                            `${table.id}_columns_${column.id}`
                                                                ? 'selected'
                                                                : ''
                                                        }`}
                                                        key={`${columnKey}-${columnIndex}`}
                                                        onClick={() => {
                                                            handleNestedItemClick(
                                                                table.id,
                                                                'columns',
                                                                column.id
                                                            );
                                                        }}
                                                    >
                                                        <div
                                                            className={`column__icon`}
                                                        >
                                                            •
                                                        </div>
                                                        <div
                                                            className={`column__name`}
                                                        >
                                                            {column.name}
                                                        </div>
                                                        <div
                                                            className={`column__type`}
                                                        >
                                                            {column.type}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>

                                {/* INDEXES */}

                                <div
                                    id={`element_item_${tableKey}_indexes`}
                                    className={`element_body_item ${
                                        activeItems[`${table.id}_indexes`]
                                            ? 'active'
                                            : ''
                                    }  ${
                                        selectedItemId === `${table.id}_indexes`
                                            ? 'selected'
                                            : ''
                                    }`}
                                >
                                    <div
                                        className="element_body_item_header"
                                        onClick={() => {
                                            handleItemClick(
                                                table.id,
                                                'indexes'
                                            );
                                        }}
                                    >
                                        <div className="element_body_item_header_icon_arrow">
                                            <ArrowIcon />
                                        </div>
                                        <div className="element_body_item_header_title">
                                            Indexes
                                            {indexesCount ? (
                                                <span>{indexesCount}</span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        id={`element_item_body_${tableKey}_indexes`}
                                        className="element_body_item_body indexes"
                                        style={
                                            activeItems[`${table.id}_indexes`]
                                                ? {
                                                      maxHeight:
                                                          activeItems[
                                                              `${table.id}_indexes`
                                                          ],
                                                  }
                                                : {}
                                        }
                                    >
                                        {isVisible &&
                                            Object.keys(
                                                table.columns || {}
                                            )
                                                .filter(
                                                    (keyItem) =>
                                                        table.columns[
                                                            keyItem
                                                        ].index
                                                )
                                                .map(
                                                    (
                                                        columnKey,
                                                        columnIndex
                                                    ) => {
                                                        const column =
                                                            table.columns[
                                                                columnKey
                                                            ];

                                                        return (
                                                            <div
                                                                className={`index ${
                                                                    selectedNestedItemId ===
                                                                    `${table.id}_indexes_${column.id}`
                                                                        ? 'selected'
                                                                        : ''
                                                                }`}
                                                                key={`${columnKey}-${columnIndex}`}
                                                                onClick={() => {
                                                                    handleNestedItemClick(
                                                                        table.id,
                                                                        'indexes',
                                                                        column.id
                                                                    );
                                                                }}
                                                            >
                                                                <div
                                                                    className={`column__icon`}
                                                                >
                                                                    <IndexIcon
                                                                        indexType={
                                                                            column
                                                                                .index
                                                                                .type
                                                                        }
                                                                    />
                                                                </div>
                                                                <div
                                                                    className={`column__name`}
                                                                >
                                                                    {
                                                                        column
                                                                            .index
                                                                            .type
                                                                    }
                                                                </div>
                                                                <div
                                                                    className={`column__type`}
                                                                >
                                                                    {
                                                                        column.name
                                                                    }
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                    </div>
                                </div>

                                {/* KEYS */}

                                <div
                                    id={`element_item_${tableKey}_keys`}
                                    className={`element_body_item ${
                                        activeItems[`${table.id}_keys`]
                                            ? 'active'
                                            : ''
                                    }  ${
                                        selectedItemId === `${table.id}_keys`
                                            ? 'selected'
                                            : ''
                                    }`}
                                >
                                    <div
                                        className="element_body_item_header"
                                        onClick={() => {
                                            handleItemClick(table.id, 'keys');
                                        }}
                                    >
                                        <div className="element_body_item_header_icon_arrow">
                                            <ArrowIcon />
                                        </div>
                                        <div className="element_body_item_header_title">
                                            Keys
                                            {keysCount ? (
                                                <span>{keysCount}</span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        id={`element_item_body_${tableKey}_keys`}
                                        className="element_body_item_body keys"
                                        style={
                                            activeItems[`${table.id}_keys`]
                                                ? {
                                                      maxHeight:
                                                          activeItems[
                                                              `${table.id}_keys`
                                                          ],
                                                  }
                                                : {}
                                        }
                                    >
                                        {isVisible &&
                                            Object.keys(
                                                table.columns || {}
                                            )
                                                .filter(
                                                    (columnKey) =>
                                                        table.columns[
                                                            columnKey
                                                        ].isPK ||
                                                        table.columns[
                                                            columnKey
                                                        ].isFK
                                                )
                                                .map(
                                                    (
                                                        columnKey,
                                                        columnIndex
                                                    ) => {
                                                        const column =
                                                            table.columns[
                                                                columnKey
                                                            ];
                                                        const keyType =
                                                            column.isPK
                                                                ? 'PRIMARY'
                                                                : 'FK';

                                                        return (
                                                            <div
                                                                className={`key ${
                                                                    selectedNestedItemId ===
                                                                    `${table.id}_keys_${column.id}`
                                                                        ? 'selected'
                                                                        : ''
                                                                } ${
                                                                    column.name ===
                                                                    'id'
                                                                        ? 'focused'
                                                                        : ''
                                                                }`}
                                                                key={`${columnKey}-${columnIndex}`}
                                                                onClick={() => {
                                                                    handleNestedItemClick(
                                                                        table.id,
                                                                        'keys',
                                                                        column.id
                                                                    );
                                                                }}
                                                            >
                                                                <div
                                                                    className={`column__icon`}
                                                                >
                                                                    <KeyIconSmall
                                                                        isDark={
                                                                            true
                                                                        }
                                                                        isPK={
                                                                            column.isPK
                                                                        }
                                                                        isFK={
                                                                            column.isFK
                                                                        }
                                                                    />
                                                                </div>
                                                                <div
                                                                    className={`column__name`}
                                                                >
                                                                    {keyType}
                                                                </div>
                                                                <div
                                                                    className={`column__type`}
                                                                >
                                                                    {
                                                                        column.name
                                                                    }
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );

    return (
        <div className={`PanelLeft ${wrapClass} ${isVisible && 'visible'}`}>
            <div className="section-top"></div>
            {tablesList}
            <div className="section-bottom"></div>

            {/* {
				Object.keys(tables || {}).map((key, index) => {
					const table = tables[key];
					return <div key={`${key}-${index}`}>{table?.name}</div>
				})
			} */}
            {Object.keys(notes || {}).map((key, index) => {
                const note = notes[key];
                return <div key={`${key}-${index}`}>{note.text}</div>;
            })}
        </div>
    );
};

// <div className='controls_bottom'>
// 			<div className="controls-group">
// 				<div className="control">
// 					<button
// 						className='control-button reset'
// 						title="Reset Size"
// 						aria-label="Reset Size"
// 						aria-pressed="false"
// 						onClick={() => resetTransform()}
// 						style={{ paddingTop: 2, }}
// 						type="button"
// 					>
// 						<ResizeToFitIcon />
// 					</button>
// 				</div>
// 			</div >
// 			<div className="controls-group">
// 				<div className="control">
// 					<button
// 						className='control-button'
// 						type="button"
// 						title="Zoom Out"
// 						aria-label="Zoom out"
// 						aria-disabled="false"
// 						onClick={() => zoomOut()}
// 					> - {/* <ModeDarkIcon /> */}
// 					</button>
// 				</div>
// 				<div className="control">
// 					<button
// 						className='control-button scale'
// 						type="button"
// 						title="Zoom Size"
// 						aria-label="Zoom Size"
// 						aria-disabled="false"
// 						onClick={() => resetTransform()}
// 					> {Math.round(scale)}%
// 					</button>
// 				</div>
// 				<div className="control">
// 					<button
// 						className='control-button'
// 						type="button"
// 						title="Zoom In"
// 						aria-label="Zoom in"
// 						aria-disabled="false"
// 						onClick={() => zoomIn()}
// 					> + {/* <ModeDarkIcon /> */}
// 					</button>
// 				</div>
// 			</div>
// 			<div className="controls-group">
// 				<div className="control">
// 					<button
// 						className='control-button'
// 						type="button"
// 						title={isLightTheme ? 'Set Dark Mode' : 'Set Light Mode'}
// 						aria-label='Set Dark Mode'
// 						aria-pressed='false'
// 						onClick={(event) => { dispatch(preferencesPatchRequest({ theme: event.a })); }}
// 					>
// 						{isLightTheme ? <ModeDarkIcon /> : <ModeLightIcon />}
// 					</button>
// 				</div>
// 			</div>
// 		</div >

export default PanelLeft;
